function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.73725 3.30605C5.18184 1.64682 6.88732 0.662163 8.54655 1.10675L21.694 4.62959C23.3532 5.07418 24.3378 6.77966 23.8932 8.43888L22.0219 15.423C21.8655 16.0064 21.5426 16.5008 21.1179 16.8685V11.6951C21.1179 10.0557 19.4791 8.24586 17.4255 8.24586H3.41364L4.73725 3.30605Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.9615 9.43749L4.99761 4.61257L5.36998 3.22619L23.3338 8.05111L22.9615 9.43749Z",
  fill: "#738BA5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5919 9.50193C1.16043 9.50193 0 10.6624 0 12.0938V19.6701C0 21.1016 1.16043 22.262 2.5919 22.262H17.266C18.6975 22.262 19.8579 21.1016 19.8579 19.6701V12.0938C19.8579 10.6624 18.6975 9.50193 17.266 9.50193H2.5919ZM2.87103 18.753C2.87103 18.3566 3.19238 18.0353 3.58878 18.0353H16.2293C16.6257 18.0353 16.947 18.3566 16.947 18.753C16.947 19.1494 16.6257 19.4708 16.2293 19.4708H3.58878C3.19238 19.4708 2.87103 19.1494 2.87103 18.753ZM3.58878 12.2533C3.19238 12.2533 2.87103 12.5747 2.87103 12.9711C2.87103 13.3675 3.19238 13.6888 3.58878 13.6888H6.65918C7.05559 13.6888 7.37694 13.3675 7.37694 12.9711C7.37694 12.5747 7.05559 12.2533 6.65918 12.2533H3.58878Z",
  fill: "#738BA5"
});

function SvgPaymentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsIcon);
export default __webpack_public_path__ + "static/media/PaymentsIcon.bc1af0ed.svg";
export { ForwardRef as ReactComponent };